<span class="field-validation" [class.show]="(message$ | async).length > 0">
  {{ (message$ | async).join(', ') }}
</span>
